import { selection } from "d3-selection";
var Selection = selection.prototype.constructor;
export default function () {
  return new Selection(this._groups, this._parents);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/transition/selection.js
// module id = 487
// module chunks = 0